module.exports = __webpack_public_path__ + "img/machines_blue.e353efa9.svg";